import { Component, OnInit } from '@angular/core';
import { ModalService } from '@app/services/modal.service';
import { forkJoin, of } from 'rxjs';
import { SatisfactionService } from '../../services/satisfaction.service';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-experience-rating-v2',
  templateUrl: './experience-rating-v2.component.html',
  styleUrls: ['./experience-rating-v2.component.scss'],
})
export class ExperienceRatingV2Component implements OnInit {

  public showRating: boolean;
  public listQuestions: any[] = [];

  constructor(
    private modal: ModalService,
    private rateservice: SatisfactionService
  ) { 
    this.showRating = true;
  }

  ngOnInit() {
    this.rateservice.resetRating$.subscribe((value:boolean) => {
      if( value ) this.showRating = false;
    })

    const user = JSON.parse(sessionStorage.getItem('user') || '');
      forkJoin([
        this.rateservice.getQuestions(user.userEmail)
          .pipe(catchError(error => of({ error: error}))),
        this.rateservice.getUsersAnswers(user.userEmail)
          .pipe(catchError(error => of({ error: error}))),
      ]).subscribe(([questionService, answerService]:any[]) => {
        if(!('error' in questionService)) {
          this.handleServicesRateResponse(questionService.data, answerService.data)
        }
      })

  }

  get lenghtQuestions() : number {
    return this.listQuestions.length;
  }

  openModalRating() {
    this.modal.show('modalQuestionRate');
  }

  handleServicesRateResponse(questions: any[], answers: any[]) {
    // if (answers) {
    //   questions.forEach((question) => {
    //     let idquestion = question.questionId;
    //     const searchQuestionsIndex = answers.map(answer => answer.questionId.questionId).indexOf(idquestion);
  
    //     if(searchQuestionsIndex == -1) this.listQuestions.push(question);
    //   });
    // } else {
    // }
    this.listQuestions = questions;
  }
}
